import { Link } from 'react-router-dom';
import { useT } from '../i18n';
import dict from './NotFound.i18n';

/** Catch-all 404. */
export default function NotFound() {
  const t = useT(dict);
  return (
    <div
      className="cl full col center"
      style={{ height: '100vh', justifyContent: 'center', alignItems: 'center', gap: 8 }}
    >
      <div className="h1">{t('heading')}</div>
      <div className="meta">{t('message')}</div>
      <Link to="/" className="btn primary mt-8">
        {t('goHome')}
      </Link>
    </div>
  );
}
